import React from "react";
import Section from "../../components/Section/Section";
import "./About.scss";
import "../../styles/Elements/elements.scss";
import { ReactComponent as DottedBig } from "../../assets/dotted-big.svg";
import { ReactComponent as DottedSmall } from "../../assets/dotted-small.svg";
import { ReactComponent as Signature } from "../../assets/signature.svg";
import { ReactComponent as Line } from "../../assets/line.svg";
import Button from "../../components/Button/Button";
const About = () => {
  return (
    <>
      <div className="about__background">
        <div className="about__background-dottedbig about__background-element dottedbig">
          <DottedBig />
        </div>
        <div className="about__background-dottedsmall about__background-element dottedsmall">
          <DottedSmall />
        </div>
      </div>
      <div className="about">
        <div className="about__section">
          <Section text="About">About Me</Section>
        </div>
        <div className="about__left">
          <img src="./ab.webp" alt="About" />
        </div>
        <div className="about__right">
          <div className="about-line">
            <Line />
          </div>
          <div className="heading-4 about__heading-4 u-color-primary">
            <span>LET ME INTRODUCE MYSELF</span>
          </div>
          <div className="about__paragraph paragraph--big">
            I'm a{" "}
            <span className="u-color-primary-light">
              Full Stack, Game And Blockchain
            </span>{" "}enginner.
            Being a software engineer was my childhood dream. I love to read, learn and write codes. It is just my daily life now.
            <br /> 
            I believe that an engineer must have the perspective of the owner. I will always share the same the goal with you and do my best for both of us, not for one of us.
            <br /> 
            Your success is my success!!!
          </div>
          <div className="about__signature">
            <img src="/signature.png"/>
          </div>
          <div className="about__button">
            <Button type="primary">Hire Me</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
